import { createStore, applyMiddleware } from 'redux'
import rootReducer from './reducers/rootReducer.js'
import createLogger from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import moment from 'moment'
import _ from 'lodash'
import Immutable, { Iterable } from 'immutable'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware as RouterMiddleware, routerReducer } from 'react-router-redux'
import { initialState as initialCaseLookupState } from '../redux/reducers/caseLookupSearchReducer';
import { logActionToRaven, logActionToAWSAnalytics } from '../util/logger'
import { isCourtDrive } from '../util/globalUtils';

const stateTransformer = (state) =>
  Iterable.isIterable(state)
    ? state.toJS()
    : state;

const transformAction = (action) => _.mapValues(action, stateTransformer);

// Create a history of your choosing (we're using a browser history in this case)
export const browserHistory = createHistory();

const routerMiddleware = RouterMiddleware(browserHistory);

const loggerMiddleware = createLogger({
  stateTransformer,
  predicate: (getState, action) => {
    const actionAsJS = transformAction(action)
    const state = getState()
      .deleteIn(['pacerSearchResults', 'filters', 'ssn4'])
      .deleteIn(['pacerSearchResults', 'filters', 'ssntin'])

    const stateAsJS = stateTransformer(state)
    logActionToRaven(actionAsJS, stateAsJS)
    //logActionToAWSAnalytics(actionAsJS, stateAsJS)

    return true
  }
})

export default (initialState) => {
  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(
      thunkMiddleware, // lets us dispatch() functions
      loggerMiddleware, // neat middleware that logs actions
      routerMiddleware, //react-router: browser url history
    )
  );

  //if (module.hot) {
  //    // Enable Webpack hot module replacement for reducers
  //    module.hot.accept('../reducers', () => {
  //        const nextReducer = require('../reducers').default
  //        store.replaceReducer(nextReducer)
  //    })
  //}

  return store
}

export function hydrateState(preloadedState) {
  const initialCaseType = (isCourtDrive())
    ? preloadedState.user.settings.pacer_search_default_case_type
    : 'Bankruptcy';

  const defaultCourts = preloadedState.user.settings.case_lookup_default_courts || {};
  const regions = Object.values(defaultCourts).reduce((accum, next, idx) => {
    if (idx === 0) {
      return next;
    }
    return accum + ',' + next;
  },'');

  const region_names = (_.isEmpty(regions))
    ? {}
    : { region_name: regions };

  const initialFacetCourts = (_.isEmpty(defaultCourts))
    ? {}
    : { '--': -1 };

  const caseLookupInitState = initialCaseLookupState.mergeDeep({
    filters: {
      case_type: initialCaseType,
      ...region_names,
    },
    facets: {
      court_name: initialFacetCourts,
    },
  });

  let state = {
    immediateSearch: !_.isEmpty(preloadedState.immediateSearch),
    pacerSearchResults: {
      data: [],
      receipts: [],
      searchOptions: {},
      filters: {
        court_id: null,
        case_no: null,
        case_title: null,
        chapter: null,
        filed_from: null,
        filed_to: null,
        closed_from: null,
        closed_to: null,
        dismissed_from: null,
        dismissed_to: null,
        discharged_from: null,
        discharged_to: null,
        ssn4: null,
        ssntin: null,
        party_name: null
      }
    },
    caseLookupSearchReducer: caseLookupInitState,
    user: preloadedState.user
  }

  if (preloadedState && preloadedState.immediateSearch) {
    if (!_.isEmpty(preloadedState.immediateSearch.date_filed_from)) {
      state.pacerSearchResults.filters.filed_from = moment(preloadedState.immediateSearch.date_filed_from, "MM/DD/YYYY")
    }
    if (!_.isEmpty(preloadedState.immediateSearch.date_filed_to)) {
      state.pacerSearchResults.filters.filed_to = moment(preloadedState.immediateSearch.date_filed_to, "MM/DD/YYYY")
    }
    if (!_.isEmpty(preloadedState.immediateSearch.party_title)) {
      state.pacerSearchResults.filters.case_title = preloadedState.immediateSearch.party_title
    }
    if (!_.isEmpty(preloadedState.immediateSearch.case_no)) {
      state.pacerSearchResults.filters.case_no = preloadedState.immediateSearch.case_no
    }
    if (!_.isEmpty(preloadedState.immediateSearch.search_type)) {
      state.user = {
        settings: {
          pacer_search_default_case_type: preloadedState.immediateSearch.search_type.charAt(0).toUpperCase() + preloadedState.immediateSearch.search_type.slice(1)
        }
      }
    }
  }

  console.log("Hydrated State:", state);
  return Immutable.fromJS(state)
}



/** WEBPACK FOOTER **
 ** ./src/redux/configureStore.js
 **/